export const NAVIGATION_MODE = {
  INTERNAL: 0,
  EXTERNAL: 1,
  STATIC: 2
};

export const MASTERBAR_MODE = {
  HIDE: 0,
  SHOW: 1
};

export const ALL_MAP_MODE = {
  HIDE: 0,
  SHOW: 1
};
